import {AbstractControl, ValidatorFn, Validators} from '@angular/forms';
import {ControlBuilder} from '../../dynamic-field/control-builder.type';
import {buildAsyncValidators, buildDefaultValidators} from '../../dynamic-field/default-control-builder';
import {ChipsFieldConfig} from './chips-field.config';
import {CustomValidationError} from '../../validation/custom-validation-error';
import {ChipItem} from '@mydocma/component-library/src/lib/chips/chip-item';


export const chipsFieldControlBuilder: ControlBuilder = (fieldConfig: ChipsFieldConfig, formBuilder) => {
    const {disabled, value} = fieldConfig;

    const validators = buildChipsFieldValidators(fieldConfig);

    const asyncValidators = buildAsyncValidators(fieldConfig);

    return formBuilder.control(
        {
            disabled,
            value: value || null
        },
        validators,
        asyncValidators
    );
};

export const buildChipsFieldValidators: (fieldConfig: ChipsFieldConfig) => ValidatorFn[] =
    (config): ValidatorFn[] => {
        return buildDefaultValidators(config);
    };


